var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2637 3.10046C20.241 3.10046 21.0333 4.03415 21.0333 5.18592V8.77484H15.3746C13.8783 8.77484 12.6624 10.1901 12.6383 11.9467L12.6379 12C12.6379 13.7634 13.8388 15.1963 15.3294 15.2248L15.3746 15.2252H21.0333V18.8141C21.0333 19.9659 20.241 20.8996 19.2637 20.8996H3.09018C2.11284 20.8996 1.32056 19.9659 1.32056 18.8141V5.18592C1.32056 4.03415 2.11284 3.10046 3.09018 3.10046H19.2637ZM21.9384 9.69617C22.3475 9.69617 22.6791 10.087 22.6791 10.5691V13.4306C22.6791 13.9127 22.3475 14.3036 21.9384 14.3036H15.5801C14.5004 14.3036 13.6252 13.2722 13.6252 11.9999C13.6252 10.7276 14.5004 9.69617 15.5801 9.69617H21.9384Z",
    fill: "url(#paint0_linear_29197_96552)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_29197_96552",
    x1: -9.46552,
    y1: 12.178,
    x2: 8.42377,
    y2: 33.4343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE815F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE5FC9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.c61439f1c1a4e799555efeeb1032fda8.svg";
export { ForwardRef as ReactComponent };